module.exports = __webpack_public_path__ + "static/media/dejandujak.7e70094b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/dejandujak.webp
// module id = 611
// module chunks = 0